import * as React from "react"
import { SVGProps } from "react"
const SvgComponent = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 24 24"
    fill="transparent"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M12.001 8.99875V7.99833"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.001 15.0013V16.0017"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.2654 14.2867C10.5217 14.7274 10.9915 15.0003 11.5014 15.0047H12.5978C13.307 15.0041 13.9046 14.4751 13.9913 13.7712C14.0779 13.0673 13.6264 12.4092 12.9385 12.2367L11.0635 11.7656C10.3756 11.5931 9.92408 10.935 10.0107 10.2311C10.0974 9.52717 10.695 8.99818 11.4042 8.99761H12.5006C13.0095 9.00114 13.4788 9.27273 13.7354 9.71219"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12 2.99625C16.9726 2.99625 21.0037 7.02737 21.0037 12C21.0037 16.9726 16.9726 21.0037 12 21.0037C7.02736 21.0037 2.99625 16.9726 2.99625 12C2.99625 7.02737 7.02736 2.99625 12 2.99625"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12 2.99625C16.9726 2.99625 21.0037 7.02737 21.0037 12C21.0037 16.9726 16.9726 21.0037 12 21.0037C7.02736 21.0037 2.99625 16.9726 2.99625 12C2.99625 7.02737 7.02736 2.99625 12 2.99625"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
export default SvgComponent
